<template>
    <div class="criteria-container mb-2" :class="{'regex-error': !$props.groupingCriteria.valid}">

        <span class="index-number">{{$props.index + 1}}</span>

        <v-select class="criteria-input-field mr-5" style="width: 160px;" color="#c42111" v-model="$props.groupingCriteria.input_field" :items="inputFieldOptions" dense outlined label="Input Field" />
        <v-text-field class="criteria-input-field regex mr-2" dense :style="{width: calcTextFieldWidth($props.groupingCriteria.before_regex)}" color="#c42111" placeholder="RegEx" outlined v-model="$props.groupingCriteria.before_regex" />
        <v-text-field class="criteria-input-field regex cvp" dense disabled style="width: 140px" value="common_value" background-color="#AF2316" outlined />
        <v-text-field class="criteria-input-field regex ml-2" dense :style="{width: calcTextFieldWidth($props.groupingCriteria.inside_regex)}" color="#c42111" placeholder="RegEx" outlined v-model="$props.groupingCriteria.inside_regex" />
        <v-text-field class="criteria-input-field regex ml-2" dense :style="{width: calcTextFieldWidth($props.groupingCriteria.after_regex)}" color="#c42111" placeholder="RegEx" outlined v-model="$props.groupingCriteria.after_regex" />

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)" v-if="!$props.groupingCriteria.valid">
            <template v-slot:activator="{ on }">
                <v-icon class="ml-3" large color="#FF5252" v-on="on">mdi-alert</v-icon>
            </template>
            <span>RegEx Error</span>
        </v-tooltip>
        <v-text-field class="hidden" :value="parsedCommonValue" />

        <div class="test-regex-container">
            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn height="40" width="40" min-width="40" class="test-button ml-4" @click="testMode = !testMode" color="#2196F3" v-on="on"><v-icon color="#ffffff">mdi-code-tags-check</v-icon></v-btn>
                </template>
                <span>Ad Hoc Test</span>
            </v-tooltip>
            <v-text-field class="criteria-input-field regex common-value ml-2" dense :style="{width: calcTextFieldWidth(testValue)}" v-model="testValue" color="#c42111" :label="testValueLabel" outlined v-if="testMode" />
            <v-text-field class="criteria-input-field regex common-value ml-2" disabled dense :style="{width: calcTextFieldWidth(parsedCommonValue)}" :value="parsedCommonValue" color="#c42111" label="common_value" outlined v-if="testMode" />
            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn height="40" width="40" min-width="40" class="delete-button ml-2" @click="$emit('delete')" color="#c42111" v-on="on"><v-icon color="#ffffff">mdi-delete-forever</v-icon></v-btn>
                </template>
                <span>Delete</span>
            </v-tooltip>
        </div>

        
        <div class="language-container">
            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn @click="regexLang = 'python'" class="language-button mr-2" :class="{selected: (regexLang == 'python')}" height="20" width="15" min-width="15" v-on="on"><v-icon x-small>mdi-language-python</v-icon></v-btn>
                </template>
                <span>Python</span>
            </v-tooltip>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn @click="regexLang = 'js'" class="language-button mr-4" :class="{selected: (regexLang == 'js')}" height="20" width="15" min-width="15" v-on="on"><v-icon x-small>mdi-language-javascript</v-icon></v-btn>
                </template>
                <span>JavaScript</span>
            </v-tooltip>

            <span class="python-regex">{{displayedRegex}}</span>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn @click="copyRegexToClipboard" class="language-button copy ml-2" height="20" width="15" min-width="15" v-on="on"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
                </template>
                <span>Copy to Clipboard</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CriteriaRegexBuilder',
    props: ['groupingCriteria', 'index'],
    components: {

    },
    data: () => ({
        inputFieldOptions: [
            {text: 'Office', value: 'alarm_office'},
            {text: 'Location', value: 'alarm_location'},
            {text: 'Description', value: 'alarm_description'},
        ],
        regexLang: "python",
        testMode: false,
        testValue: "",
    }),

    computed: {
        testValueLabel() {
            return "test_value";
        },

        pythonRegex() {
            return `r"${this.$props.groupingCriteria.before_regex}(?P<common_value>${this.$props.groupingCriteria.inside_regex})${this.$props.groupingCriteria.after_regex}"gm`;
        },

        jsRegex() {
            return `/${this.$props.groupingCriteria.before_regex}(?<common_value>${this.$props.groupingCriteria.inside_regex})${this.$props.groupingCriteria.after_regex}/gm`;
        },

        displayedRegex() {
            if(this.regexLang == 'python') {
                return this.pythonRegex;
            }
            else if(this.regexLang == 'js') {
                return this.jsRegex;
            }
        },

        parsedCommonValue() {
            try {
                let regex = new RegExp(`${this.$props.groupingCriteria.before_regex}(?<common_value>${this.$props.groupingCriteria.inside_regex})${this.$props.groupingCriteria.after_regex}`, "gm");
                this.$props.groupingCriteria.valid = true;
                let match = this.testValue.matchAll(regex).next();
                if(match.value) {
                    return match.value.groups.common_value;
                }
            } catch (error) {
                if(error instanceof SyntaxError) {
                    this.$props.groupingCriteria.valid = false;
                }
            }
            return "";
        }
    },

    methods: {
        calcTextFieldWidth: function(textVal) {
            let width = textVal ? (textVal.length * 9.6) + 25 : 0;
            return `${width}px`;
        },

        copyRegexToClipboard: function() {
            navigator.clipboard.writeText(this.displayedRegex);
        }
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .index-number {
        display: block;
        position: absolute;
        top: 0px;
        left: 5px;
        font-weight: bold;
        font-size: 16px;
    }

    .criteria-container {
        background-color: #303030;
        width: 100%;
        border: black solid 1px;
        border-radius: 5px;
        height: 100px;
        padding: 15px 30px;
        position: relative;
        display: block;
    }
    .criteria-container.regex-error {
        border-color: #FF5252;
    }

    .criteria-input-field {
        display: inline-block;
        min-width: 70px;
    }
    .criteria-input-field.regex {
        font-family: monospace;
    }
    .criteria-input-field.regex.common-value {
        min-width: 155px;
    }

    .test-regex-container {
        float: right;
    }

    .common-field {
        display: inline-block;
        text-align: center;
        height: 40px;
        width: 110px;
        border-radius: 3px;
        border: #cccccc solid 1px;
        background-color: #c42111;
        color: #ffffff;
        vertical-align: top;
        font-weight: bold;
        padding-top: 6px;
        opacity: 0.85;
    }

    .language-container {
        margin-top: -20px;
    }
    .language-container .language-button {
        padding: 0px 10px;
        border: pink 1px solid;
        background-color: #424242 !important;
    }
    .language-container .language-button.selected {
        border: none;
        border: #E91E63 1px solid;
        background-color: #E91E63 !important;
    }
    .language-container .language-button.copy {
        border: #ffffff 1px solid;
    }

    .python-regex {
        font-family: monospace;
        color: pink;
        font-weight: 500;
    }

    .test-button {
        border-radius: 4px; 
        vertical-align: top;
        height: 38px;
        border: solid 1px !important;
        border-color: rgba(255,255,255,0.5) !important;
    }

    .delete-button {
        border: solid 1px !important;
        border-color: rgba(255,255,255,0.75) !important;
    }

    .hidden {
        display: none;
    }


</style>

<style>

    .criteria-input-field.regex.cvp .theme--dark.v-input--is-disabled .v-label, .theme--dark.v-input--is-disabled input, .theme--dark.v-input--is-disabled textarea {
        color: #ffffff;
        opacity: 0.8;
    }

</style>
